import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { EditBetRequest } from '@bpos/v2/edit-bet';
import { ApiService } from '@frontend/sports/common/api-utils';
import { Observable } from 'rxjs';

import { IBetslipState } from '../../../base/store/state';
import { formatObject } from '../../../base/utils/format-object';
import { IEditBetPlaceBetResponseDto } from '../../../model/edit-mybet/edit-bet-place-bet-response.dto';
import { IPlaceBetResponsePayload } from '../actions';

@Injectable()
export class EditBetPlaceService {
    private static readonly placeBetRequestUrlPath = 'editmybet?emailNotify={emailNotify}&appNotify={appNotify}';
    private static readonly getStatusRequestUrlPath = 'editmybet?guid={guid}&emailNotify={emailNotify}&appNotify={appNotify}';

    constructor(private apiService: ApiService) {}

    postEditBet(request: EditBetRequest, state: IBetslipState): Observable<HttpResponse<IEditBetPlaceBetResponseDto>> {
        const url = formatObject(EditBetPlaceService.placeBetRequestUrlPath, {
            emailNotify: !!state.settings.notifications.emailNotify,
            appNotify: !!state.settings.notifications.appNotify,
        });

        return this.apiService.post<HttpResponse<IEditBetPlaceBetResponseDto>>(url, request, {
            cache: false,
            retryCount: 0,
            showSpinner: false,
            resolveWithFullResponse: true,
        });
    }

    getEditBetStatus(payload: IPlaceBetResponsePayload): Observable<HttpResponse<IEditBetPlaceBetResponseDto>> {
        const url = formatObject(EditBetPlaceService.getStatusRequestUrlPath, {
            guid: payload.guid,
            emailNotify: !!payload.state.settings.notifications.emailNotify,
            appNotify: !!payload.state.settings.notifications.appNotify,
        });

        return this.apiService.get<HttpResponse<IEditBetPlaceBetResponseDto>>(url, undefined, {
            retryCount: 0,
            showSpinner: false,
            resolveWithFullResponse: true,
        });
    }
}
